(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name alvBidding.controller:AlvBiddingCtrl
   *
   * @description
   *
   */
  angular
    .module('alvBidding')
    .controller('AlvBiddingCtrl', AlvBiddingCtrl);

  function AlvBiddingCtrl(CommonMasterData, $sce, CommonLogicService) {
    var vm = this;
    vm.ctrlName = 'AlvBiddingCtrl';
    vm.model = {
      searchPanelToggle: true,
      searchCriteria: {
        crewType: null
      },
      masterList: {
        crewTypeList: []
      },
      initialSearchDone: false,
      reportDataURL: null,
      reportServerBaseUrl: null
    };

    // toggle search
    vm.clickOnSearch = function () {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };
    // submit search
    vm.submitSearch = function (params) {
      searchAlvBidding(params);
    };
    // searchAlvBidding
    function searchAlvBidding(param) {
      vm.model.initialSearchDone = true;
      vm.model.searchCriteria = param;
      vm.model.searchPanelToggle = false;
      var url = CommonLogicService.getReportUrl(
        "alv_bidding.rptdesign",
        getSearchParamMap(param));
      vm.model.reportDataURL = $sce.trustAsResourceUrl(url);

    }
    // set search param map
    function getSearchParamMap(param) {
      var searchParamMap = {};
      searchParamMap["crewType"] = param.crewType.crewTypeCode;
      return searchParamMap;
    }

    (function () {
      // crew type codes
      CommonMasterData.getCrewTypeList(function (crewTypeList) {

        vm.model.masterList.crewTypeList = crewTypeList;
      }, function () {
        console.log('Crew Type list retrieval error');
      });

    })();


  }
}());
